import React, { useState, useEffect } from "react";
import CityBreak from "./cityBreak";
import CardsSection from "./cardsSection";
import PackingFilter from "./filterSection";
import { useLazyGetPackingListSearhQuery, useLazyGetSavedPackingListQuery } from "../../services/Api";
import { toast } from "react-toastify";

const PackingList = () => {
  const [showLisitn, setShowListing] = useState(false);
  const [page, setPage] = useState(1)
  const [filters, setFilters] = useState({})
  const [pagination, setPagination] = useState(0)
  const [showSaved, setShowSaved] = useState(false)

  const [trigger, { data, isLoading, isError }] = useLazyGetPackingListSearhQuery();
  const [triggerSaved, { data: savedPacking, isLoading: loading, isError: saveListError }] = useLazyGetSavedPackingListQuery();


  const handleFetch = (latestFilter) => {
    const validParams = Object.keys(latestFilter).reduce((acc, key) => {
      const value = latestFilter[key];
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value; // Include only valid key-value pairs
      }
      return acc;
    }, {});
    // Trigger the query with filtered parameters
    const queryParams = { ...validParams, page };
    trigger(queryParams);
  };
  useEffect(() => {
    if (pagination > 0) {
      handleFetch(filters)
    }
  }, [pagination])

  // Automatically set showLisitn to true when data is received
  useEffect(() => {
    if (data && data?.data) {
      setShowListing(true);
    }
    if (isError) {
      toast.error(isError)
    }

  }, [data]);
  // useEffect(() => {
  //   if (savedPacking && savedPacking?.data) {
  //     setShowListing(true);
  //   }
  //   if (saveListError) {
  //     toast.error(saveListError)
  //   }
  // }, [savedPacking]);

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth", // Adds a smooth scrolling effect
  //   });
  // }, [showLisitn]);
  // console.log("data in saved", savedPacking, data)
  // useEffect(() => {
  //   const handleBackButton = (event) => {
  //     if (showLisitn) {
  //       event.preventDefault();
  //       setShowListing(false); // When back button is pressed, set a to false
  //       setShowSaved(false)
  //       window.history.pushState(null, null, window.location.pathname); // Prevent back navigation
  //       window.location.reload()
  //     } else {
  //       window.scrollTo({
  //         top: 0,
  //         behavior: "smooth", // Adds a smooth scrolling effect
  //       });
  //     }
  //   };
  //   window.history.pushState(null, null, window.location.pathname); // Push initial state
  //   window.addEventListener("popstate", handleBackButton);
  //   return () => {
  //     window.removeEventListener("popstate", handleBackButton);
  //   };
  // }, [showLisitn]);
  console.log("data in", showLisitn)
  return (
    <div className="min-h-[100vh]">
      <CityBreak showLisitn={showLisitn} />
      <PackingFilter setShowSaved={setShowSaved} triggerSaved={triggerSaved} setShowListing={setShowListing} setFilter={setFilters} handleFetch={handleFetch} isLoading={isLoading} />
    </div>
  );
};

export default PackingList;
